module.exports = __webpack_public_path__ + "img/marcoIA.e0545d95.svg";